export default __webpack_public_path__ + "static/font-d1a4565cca0d43c65e159df3ae34c159.woff";